module.exports = __webpack_public_path__ + "img/bashu.53fb2967.png";